export const LOAD_SETTINGS = 'APP/LOAD_SETTINGS';

export interface AppDispatchTypes {
  type: string;
  payload?: any;
}